module.exports = __webpack_public_path__ + "static/media/IconoPila.fd5ae653.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/gbadicionales/IconoPila.svg
// module id = 756
// module chunks = 0